import { computed, Injectable, linkedSignal, Signal, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private _loadingRequestCounter: WritableSignal<number> = signal(0);

  public loading: Signal<boolean> = computed(() => {
    return this._loadingRequestCounter() > 0
  })

  constructor() { }

  show() {
    //Mostro il loader e incremento "loadingRequestCounter()" in modo da tenere traccia di caricamenti multipli
    this._loadingRequestCounter.set(this._loadingRequestCounter() + 1);
  }

  hide() {
    //Se ho più richieste di caricamento in corso non nascondo il loader ma decremento "loadingRequestCounter()"
    if (this._loadingRequestCounter() > 0) {
      this._loadingRequestCounter.set(this._loadingRequestCounter() - 1);
    }
  }

}
